import React, { useEffect, useMemo, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import PropTypes from 'prop-types';
import Chip from '@material-ui/core/Chip';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';
import {
  Archive,
  Assignment,
  AttachFile,
  Build,
  BusinessCenter,
  DateRange,
  Map,
  MenuBook,
  PlaylistAddCheck,
  DeviceHub,
} from '@material-ui/icons';
import ActionButton from '../../../components/ActionButton';

const RouteIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 55 54">
    <g clipPath="url(#clip0_route)">
      <path
        d="M19.6935 8.83847C18.5296 3.59108 13.9925 1.24219 10.0121 1.24219C6.03206 1.24219 1.49435 3.59129 0.330537 8.83857C0.111074 9.82724 0 10.8454 0 11.8651C0 17.8758 3.88051 23.2486 9.65615 25.2349C9.77131 25.2745 9.89162 25.2942 10.012 25.2942C10.1325 25.2942 10.2528 25.2744 10.3679 25.2347C16.1435 23.2486 20.0241 17.8757 20.0241 11.865C20.024 10.8453 19.9129 9.82703 19.6935 8.83847ZM10.012 23.1109C5.2959 21.327 2.15316 16.8543 2.15316 11.8651C2.15316 10.9964 2.2478 10.1295 2.43418 9.2885C3.4056 4.90986 7.12347 3.35631 10.012 3.35631C12.9006 3.35631 16.6184 4.90986 17.5896 9.2884C17.7761 10.1294 17.8706 10.9963 17.8706 11.865C17.8708 16.8542 14.7281 21.3268 10.012 23.1109Z"
        fill="currentColor"
      />
      <path
        d="M52.1212 36.302C50.9573 31.0545 46.4201 28.7056 42.4398 28.7056C38.4595 28.7056 33.922 31.0547 32.7581 36.302C32.5388 37.2906 32.4277 38.3089 32.4277 39.3285C32.4277 45.3392 36.3082 50.712 42.0838 52.6983C42.1991 52.7379 42.3194 52.7578 42.4397 52.7578C42.56 52.7578 42.6804 52.7379 42.7956 52.6983C44.1794 52.2225 45.4787 51.5425 46.6572 50.6771C47.1333 50.3276 47.2308 49.6651 46.8748 49.1976C46.5187 48.7301 45.8441 48.6344 45.3679 48.9841C44.467 49.6455 43.4835 50.1795 42.4398 50.5746C37.7236 48.7905 34.581 44.3179 34.581 39.3287C34.581 38.4599 34.6757 37.5931 34.8621 36.752C35.8335 32.3735 39.5513 30.8199 42.4399 30.8199C45.3285 30.8199 49.0463 32.3735 50.0175 36.7519C50.2039 37.593 50.2985 38.46 50.2985 39.3287C50.2985 41.8783 49.4976 44.3145 47.9827 46.3741C47.6345 46.8473 47.7431 47.5081 48.225 47.8498C48.7069 48.1914 49.3801 48.0852 49.7283 47.6117C51.51 45.1895 52.4518 42.3253 52.4518 39.3285C52.4516 38.3088 52.3405 37.2906 52.1212 36.302Z"
        fill="currentColor"
      />
      <path
        d="M10.0249 7C7.80558 7 6 8.77292 6 10.9519C6 13.131 7.80558 14.9038 10.0249 14.9038C12.2443 14.9038 14.05 13.1311 14.05 10.9519C14.05 8.77292 12.2443 7 10.0249 7ZM10.0249 13.1855C8.77053 13.1855 7.75005 12.1835 7.75005 10.9519C7.75005 9.72033 8.77062 8.71831 10.0249 8.71831C11.2794 8.7184 12.2999 9.72041 12.2999 10.9519C12.3 12.1836 11.2794 13.1855 10.0249 13.1855Z"
        fill="#FF4600"
      />
      <path
        d="M35.98 50.6435H16.902C13.6964 50.6435 11.0886 48.0831 11.0886 44.9358C11.0886 41.7885 13.6964 39.2282 16.902 39.2282H30.2393C30.8339 39.2282 31.3158 38.7549 31.3158 38.1711C31.3158 37.5874 30.8339 37.1141 30.2393 37.1141H16.902C12.5092 37.1141 8.93535 40.6229 8.93535 44.9359C8.93535 49.2488 12.5091 52.7577 16.902 52.7577H35.98C36.5747 52.7577 37.0566 52.2844 37.0566 51.7007C37.0566 51.1168 36.5747 50.6435 35.98 50.6435Z"
        fill="#FF4600"
      />
      <path
        d="M47.0336 23.1801H29.8026C29.2079 23.1801 28.726 23.6534 28.726 24.2371C28.726 24.8209 29.2079 25.2941 29.8026 25.2941H47.0336C50.2389 25.2941 52.8468 27.8545 52.8468 31.0018V31.4064C52.8468 32.0815 52.7282 32.7417 52.4944 33.3689C52.29 33.9171 52.5769 34.5242 53.1354 34.7249C53.2575 34.7689 53.3824 34.7896 53.5053 34.7896C53.9445 34.7896 54.3569 34.5239 54.5165 34.0956C54.8374 33.2349 55.0001 32.3301 55.0001 31.4064V31.0017C55 26.689 51.4264 23.1801 47.0336 23.1801Z"
        fill="#FF4600"
      />
      <path
        d="M26.2138 23.1801H16.4715C15.8769 23.1801 15.395 23.6534 15.395 24.2371C15.395 24.8209 15.8769 25.2941 16.4715 25.2941H26.2138C26.8085 25.2941 27.2904 24.8209 27.2904 24.2371C27.2905 23.6535 26.8086 23.1801 26.2138 23.1801Z"
        fill="#FF4600"
      />
      <path
        d="M42.35 36.27V42.57M39.1417 39.42H45.5583"
        stroke="#FF4600"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_route">
        <rect width="55" height="54" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

const PlusIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 22 11">
    <path
      d="M0.647998 9.70203C0.635998 8.04603 0.425998 5.95203 0.0179982 3.42003C0.00599822 3.32403 0.00599822 3.24003 0.0179982 3.16803C0.0419982 3.08403 0.0719982 3.01803 0.107998 2.97003C0.143998 2.91003 0.197998 2.85603 0.269998 2.80803C0.353998 2.76003 0.419998 2.72403 0.467998 2.70003C0.527998 2.67603 0.611998 2.65203 0.719998 2.62803C0.827998 2.59203 0.905998 2.57403 0.953998 2.57403C1.002 2.56203 1.08 2.55003 1.188 2.53803C1.308 2.51403 1.374 2.50203 1.386 2.50203C2.466 2.33403 3.504 2.40003 4.5 2.70003C5.496 2.98803 5.772 3.51603 5.328 4.28403C5.04 4.81203 4.638 5.20203 4.122 5.45403C3.606 5.70603 2.874 5.93403 1.926 6.13803C1.65 6.18603 1.458 6.30603 1.35 6.49803C1.254 6.67803 1.194 6.94803 1.17 7.30803C1.17 7.48803 1.182 7.71003 1.206 7.97403C1.242 8.22603 1.272 8.44203 1.296 8.62203C1.32 8.79003 1.326 8.95803 1.314 9.12603C1.302 9.29403 1.242 9.42603 1.134 9.52203C1.026 9.61803 0.863998 9.67803 0.647998 9.70203ZM4.464 3.78003C4.404 3.50403 4.194 3.30603 3.834 3.18603C3.474 3.06603 3.084 3.03603 2.664 3.09603C2.244 3.14403 1.914 3.24603 1.674 3.40203C1.278 3.67803 1.08 4.02003 1.08 4.42803C1.08 4.59603 1.098 4.74003 1.134 4.86003C1.182 4.96803 1.224 5.05803 1.26 5.13003C1.308 5.19003 1.386 5.23803 1.494 5.27403C1.614 5.29803 1.704 5.31603 1.764 5.32803C1.836 5.32803 1.95 5.31603 2.106 5.29203C2.262 5.26803 2.37 5.25003 2.43 5.23803C2.49 5.22603 2.604 5.19603 2.772 5.14803C3.072 5.07603 3.438 4.88403 3.87 4.57203C4.302 4.26003 4.5 3.99603 4.464 3.78003ZM6.13856 1.31403C5.93456 0.786026 6.00056 0.354027 6.33656 0.0180267C6.54056 0.00602615 6.69656 0.048026 6.80456 0.144026C6.91256 0.228027 7.01456 0.396026 7.11056 0.648026C7.25456 1.05603 7.32656 1.70403 7.32656 2.59203C7.32656 3.51603 7.36256 4.62003 7.43456 5.90403C7.51856 7.18803 7.56056 8.10003 7.56056 8.64003C7.56056 9.26403 7.48256 9.75603 7.32656 10.116C7.00256 9.97203 6.77456 9.68403 6.64256 9.25203C6.51056 8.82003 6.45056 8.39403 6.46256 7.97403C6.47456 7.54203 6.50456 7.00203 6.55256 6.35403C6.60056 5.69403 6.62456 5.21403 6.62456 4.91403C6.62456 4.75803 6.61856 4.50603 6.60656 4.15803C6.60656 3.79803 6.60056 3.57003 6.58856 3.47403C6.58856 3.37803 6.57656 3.21603 6.55256 2.98803C6.54056 2.76003 6.51656 2.58603 6.48056 2.46603C6.44456 2.33403 6.39656 2.17203 6.33656 1.98003C6.28856 1.77603 6.22256 1.55403 6.13856 1.31403ZM9.77822 4.60803C9.59822 6.50403 9.60422 7.86603 9.79622 8.69403C10.3002 8.65803 10.8522 8.44203 11.4522 8.04603C12.0642 7.63803 12.4602 7.24203 12.6402 6.85803C12.7722 6.66603 12.8682 6.16803 12.9282 5.36403C13.0002 4.54803 13.0962 4.05003 13.2162 3.87003C13.5882 4.00203 13.8222 4.25403 13.9182 4.62603C14.0262 4.99803 14.0742 5.55003 14.0622 6.28203C14.0622 6.37803 14.0862 6.59403 14.1342 6.93003C14.1822 7.25403 14.2062 7.46403 14.2062 7.56003C14.1822 7.75203 14.2122 7.91403 14.2962 8.04603C14.3922 8.16603 14.5302 8.26803 14.7102 8.35203C14.8902 8.43603 15.0582 8.50203 15.2142 8.55003C15.3702 8.58603 15.5562 8.62803 15.7722 8.67603C15.8322 8.67603 15.8742 8.68203 15.8982 8.69403C15.7182 8.87403 15.5682 9.01803 15.4482 9.12603C15.3282 9.22203 15.1662 9.31803 14.9622 9.41403C14.7582 9.49803 14.5482 9.54003 14.3322 9.54003C13.8402 9.54003 13.4922 9.32403 13.2882 8.89203C13.1802 8.68803 13.0602 8.43603 12.9282 8.13603C11.4882 9.27603 10.4022 9.86403 9.67022 9.90003C9.51422 9.90003 9.37622 9.87003 9.25622 9.81003C9.14822 9.75003 9.06422 9.67203 9.00422 9.57603C8.94422 9.48003 8.89622 9.34803 8.86022 9.18003C8.82422 9.01203 8.80622 8.85603 8.80622 8.71203C8.80622 8.56803 8.80622 8.38803 8.80622 8.17203C8.83022 7.09203 8.77622 5.82003 8.64422 4.35603C8.63222 4.12803 8.67422 3.90003 8.77022 3.67203C8.87822 3.44403 9.01622 3.31803 9.18422 3.29403C9.34022 3.28203 9.48422 3.43803 9.61622 3.76203C9.74822 4.08603 9.80222 4.36803 9.77822 4.60803ZM16.9777 6.85803C17.4097 6.91803 17.7517 6.94803 18.0037 6.94803C18.2677 6.94803 18.6517 6.93003 19.1557 6.89403C19.6717 6.85803 20.0497 6.84003 20.2897 6.84003C20.8177 6.84003 21.1957 6.93003 21.4237 7.11003C21.6637 7.29003 21.6997 7.58403 21.5317 7.99203C21.4357 8.19603 21.2737 8.39403 21.0457 8.58603C20.8177 8.77803 20.5897 8.92803 20.3617 9.03603C20.1457 9.14403 19.8577 9.27603 19.4977 9.43203C19.1497 9.58803 18.8977 9.70803 18.7417 9.79203C18.4897 9.92403 18.2677 9.99603 18.0757 10.008C17.8837 10.008 17.6617 9.94803 17.4097 9.82803C17.4337 9.74403 17.4937 9.64203 17.5897 9.52203C17.6977 9.40203 17.8237 9.28203 17.9677 9.16203C18.1237 9.04203 18.2857 8.92203 18.4537 8.80203C18.6337 8.67003 18.8077 8.55003 18.9757 8.44203C19.1437 8.33403 19.2937 8.23803 19.4257 8.15403C19.5577 8.07003 19.6597 7.99803 19.7317 7.93803C19.8037 7.87803 19.8337 7.84803 19.8217 7.84803C19.6177 7.80003 19.1077 7.83003 18.2917 7.93803C17.4877 8.04603 17.0257 8.10003 16.9057 8.10003C16.4137 8.10003 16.0537 7.99803 15.8257 7.79403C15.6097 7.57803 15.5677 7.26603 15.6997 6.85803C15.8077 6.48603 16.0537 6.13203 16.4377 5.79603C16.4737 5.74803 16.8517 5.50203 17.5717 5.05803C18.2917 4.61403 18.8677 4.27203 19.2997 4.03203C19.5517 3.88803 19.7557 3.78603 19.9117 3.72603C20.0797 3.66603 20.2537 3.64203 20.4337 3.65403C20.6137 3.66603 20.7877 3.73803 20.9557 3.87003C21.2317 4.07403 21.3397 4.26603 21.2797 4.44603C21.2197 4.62603 20.9977 4.76403 20.6137 4.86003C19.2817 5.23203 18.0697 5.89803 16.9777 6.85803Z"
      fill="#FF4600"
    />
  </SvgIcon>
);

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '30px',
    margin: '10px 0',
    padding: '40px',
  },
  chipContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  chip: {
    margin: '4px',
    width: '240px',
    height: '40px',
    borderRadius: '20px',
    borderColor: 'inherit',
    '& .MuiChip-label': {
      fontSize: '1rem',
      color: 'black',
    },
    '& .MuiChip-icon': {
      transform: 'scale(1.2)',
    },
  },
  disabledSection: {
    '& .MuiChip-label': {
      color: theme.palette.text.disabled,
    },
  },
}));

const CHIP_DEFINITIONS = [
  { key: 'manuale', label: 'Manuale', icon: <MenuBook /> },
  { key: 'calendario', label: 'Calendario', icon: <DateRange /> },
  { key: 'controlli', label: 'Controlli', icon: <PlaylistAddCheck /> },
  { key: 'schede', label: 'Schede', icon: <Assignment /> },
  { key: 'allegati', label: 'Allegati', icon: <AttachFile /> },
  { key: 'archivio', label: 'Archivio', icon: <Archive /> },
  { key: 'attrezzature', label: 'Attrezzature', icon: <Build /> },
  { key: 'attivita', label: 'Attività', icon: <BusinessCenter /> },
  { key: 'tracciabilita', label: 'Tracciabilità', icon: <Map /> },
  { key: 'iot', label: 'IoT', icon: <DeviceHub /> },
  {
    key: 'cooki',
    label: (
      <span style={{ display: 'flex', alignItems: 'center' }}>
        Tracciabilità{' '}
        <PlusIcon style={{ width: 22, height: 11, marginLeft: 4 }} />
      </span>
    ),
    icon: <RouteIcon />,
  },
];

const buildDraftFromFunzionalitaApp = (data) => {
  const draft = {};
  CHIP_DEFINITIONS.forEach(({ key }) => {
    draft[key] = Boolean(data[key]);
  });
  return draft;
};

const ChipSection = ({ funzionalitaApp, onChipSave }) => {
  const classes = useStyles();
  const theme = useTheme();

  const [draft, setDraft] = useState(() =>
    buildDraftFromFunzionalitaApp(funzionalitaApp),
  );

  useEffect(() => {
    setDraft(buildDraftFromFunzionalitaApp(funzionalitaApp));
  }, [funzionalitaApp]);

  const hasChanges = useMemo(
    () =>
      CHIP_DEFINITIONS.some(
        ({ key }) => draft[key] !== Boolean(funzionalitaApp[key]),
      ),
    [draft, funzionalitaApp],
  );

  const handleToggle = (key) => {
    setDraft((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSave = () => {
    const updatedFunzionalitaApp = { ...funzionalitaApp };
    CHIP_DEFINITIONS.forEach(({ key }) => {
      updatedFunzionalitaApp[key] = draft[key];
    });

    onChipSave(updatedFunzionalitaApp);
  };

  return (
    <Paper className={classes.paper}>
      <Typography variant="h6">
        Attiva/disattiva le relative sezioni nella dashboard dell'app:
      </Typography>
      <div className={classes.chipContainer}>
        {CHIP_DEFINITIONS.map(({ key, label, icon }) => {
          const enabled = draft[key];
          return (
            <Chip
              variant="outlined"
              key={key}
              icon={icon}
              label={label}
              clickable
              color="primary"
              onClick={() => handleToggle(key)}
              style={{
                backgroundColor: enabled
                  ? 'inherit'
                  : theme.palette.disabled.main,
                color: enabled
                  ? theme.palette.primary.main
                  : theme.palette.text.disabled,
                boxShadow: enabled ? theme.shadows[3] : 'none',
              }}
              className={`${classes.chip} ${
                enabled ? '' : classes.disabledSection
              }`}
            />
          );
        })}
      </div>
      <ActionButton
        label="Salva modifiche sezioni"
        onClick={handleSave}
        disabled={!hasChanges}
      />
    </Paper>
  );
};

ChipSection.propTypes = {
  funzionalitaApp: PropTypes.object.isRequired,
  onChipSave: PropTypes.func.isRequired,
};

export default ChipSection;
